// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error {
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 96px);
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.error__container {
  position: relative;
  width: 70%;
  overflow: hidden;
}

.error__container svg {
  width: 100%;
  height: 100%;
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/components/error/Error.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;AACb","sourcesContent":[".error {\n  width: 100%;\n  height: 100%;\n  min-height: calc(100vh - 96px);\n  background-color: #fff;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.error__container {\n  position: relative;\n  width: 70%;\n  overflow: hidden;\n}\n\n.error__container svg {\n  width: 100%;\n  height: 100%;\n  color: #fff;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
